<template>
    <div class="modal d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header  ">
                    <h5 class="modal-title">Create Team</h5>

                </div>
                <div class="modal-body">

                    <div v-if="hasError" class="alert alert-danger">Unable to create team.</div>

                    <form id="actionForm" @submit.prevent="createTeam">

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="txtCompanyCreateName">Name</label>
                                    <input type="text"
                                           :class="{'input': true, 'is-invalid': $v.form.name.$error || hasFieldError('NAME') }"
                                           v-model.trim="form.name" @input="delayTouch($v.form.name)"
                                           class="form-control" id="txtCompanyCreateName" placeholder="Team name">
                                    <span v-if="$v.form.name.$error || hasFieldError('NAME')"
                                          class="invalid-feedback form-text text-danger">
                                        <span v-if="!$v.form.name.required">This field is required</span>
                                        <span>{{ companyFieldError }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="txtCompanyCreateName">Country</label>

                                    <multiselect
                                        class="multiselect-md"
                                        v-model="form.country"
                                        :options="countryOptions"
                                        placeholder="Select a country"
                                        track-by="code" label="name"
                                        :multiple="false"
                                        :show-labels="false"
                                        :loading="isLoadingCountry"
                                        :internal-search="false"
                                        @search-change="asyncFindCountry"
                                        :class="{'input': true, 'is-invalid': $v.form.country.code.$error || hasFieldError('COUNTRY') }"
                                        @input="delayTouch($v.form.country.code)"
                                        ></multiselect>
                                    <small v-if="$v.form.country.code.$error" class="form-text text-danger">
                                        <span v-if="!$v.form.country.required">This field is required</span>
                                        <span>{{ countryFieldError }}</span>
                                    </small>
                                </div>

                            </div>
                        </div>

                    </form>

                </div>
                <div class="modal-footer">
                    <button @click="closeModal" type="button" class="btn btn-link" data-dismiss="modal">
                        Cancel
                    </button>
                    <button v-loading.btn="isLoading"
                            @click="createTeam"
                            type="button"
                            class="btn btn-primary"
                            style="width: 160px">
                        Create Team
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {TEAM_CREATE} from '@/store/mutations'
import {required} from 'vuelidate/lib/validators'
import {docSystemTypesDefaultModels} from '@/types/document/types'
import {fetchCountries} from '@/api/data'

const touchMap = new WeakMap()

export default {

    data() {
        return {
            form: {
                name: '',
                country: {
                    name: '',
                    code: ''
                }
            },
            countrySelected: null,
            countryOptions: [],
            isLoadingCountry: false,

            isLoading: false,

            hasError: false,
            errorCode: null,
            errorMsg: null,
            companyFieldError: null,
            countryFieldError: null

        }
    },
    computed: {},
    validations: {
        form: {
            name: {
                required
            },
            country: {
                code: {
                    required
                }
            }
        }
    },
    methods: {
        delayTouch($v) {
            this.errorCode = null
            this.errorMsg = null
            this.hasError = false
            this.companyFieldError = null
            this.countryFieldError = null

            $v.$reset()
            if (touchMap.has($v)) {
                clearTimeout(touchMap.get($v))
            }
            touchMap.set($v, setTimeout($v.$touch, 1000))
        },

        hasFieldError(type) {
            if (this.errorCode === 401) {
                if (type === 'NAME') {
                    if (this.errorMsg.errors.hasOwnProperty('name')) {
                        this.companyFieldError = this.errorMsg.errors.name
                        return true
                    }
                } else if (type === 'COUNTRY') {
                    if (this.errorMsg.errors.hasOwnProperty('country')) {
                        this.countryFieldError = this.errorMsg.errors.country
                        return true
                    }
                }
            }
            return this.hasError
        },

        createTeam() {
            if (this.$v.$invalid) {
                return this.$v.$touch()
            }

            this.isLoading = true
            this.hasError = false

            this.$store.dispatch(TEAM_CREATE, {
                name: this.form.name,
                tradingAs: this.form.name,
                country: this.form.country.code,
                demoData: false,
                platform: 'WEBSITE'
            })
                .then(team => {
                    this.isLoading = false
                    this.closeModal()
                    this.$router.push({
                        name: docSystemTypesDefaultModels.purchasing.route,
                        params: {team: team.uuid}
                    })
                })
                .catch(err => {
                    this.isLoading = false
                    this.hasError = true
                    this.errorCode = err.response ? err.response.status : 'Unknown error'
                })
        },

        asyncFindCountry(query = '') {
            this.isLoadingCountry = true
            fetchCountries({params: {q: query}}).then(data => {
                this.countryOptions = data
                this.isLoadingCountry = false
            })
        },

        closeModal() {
            this.$emit('close')
        }
    },
    mounted() {
        this.asyncFindCountry()
    }
}
</script>
